import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {PriceRule} from '@app/models/price-rule';
import {Repository} from '@app/@core/repositories/repository';
import format from 'date-fns/format';
import {Primitive} from '@shared/interfaces/primitive';
import {toDate} from '@shared/helper/helpers';

export interface SeasonWrapper {
    start: Date;
    end: Date;
}

// function convertSeasonFromServer(season: Season): SeasonWrapper {
//     const [year, month, day] = season.start;
//     const [year2, month2, day2] = season.end;
//
//     return {
//         start: DateTime.local(year, month, day).toBSON(),
//         end: DateTime.local(year2, month2, day2).toBSON()
//     };
// }
//
// function convertSeasonToServer(wrapper: SeasonWrapper): Season {
//     const start = DateTime.fromJSDate(wrapper.start);
//     const end = DateTime.fromJSDate(wrapper.end);
//
//     return {
//         start: [start.year, start.month, start.day],
//         end: [end.year, end.month, end.day]
//     };
// }

@Injectable({
    providedIn: 'root'
})
export class PriceRuleRepository extends Repository<PriceRule> {

    constructor(protected http: HttpClient) {
        super(http, 'pricerule');
    }

    search(courseId: string, alive: boolean | undefined, from?: Date, to?: Date): Observable<PriceRule[]> {
        const params = {
            courseId,
            alive: alive ?? '',
            from: from ? format(from, 'yyyy-MM-dd') : '',
            to: to ? format(to, 'yyyy-MM-dd') : ''
        };

        return this.http.get<PriceRule[]>(`${this.entityUrl}/search`, {params}).pipe(
            this.mapList()
        );
    }

    getByCourseId(courseId: string): Observable<PriceRule[]> {
        return this.search(courseId, undefined);
    }

    applyNewPrice(params: {courseId?: string, priceRuleId?: string}): Observable<number> {
        return this.http.post<Primitive<number>>(`${this.entityUrl}/applyNewPrice`, {}, {params}).pipe(this.mapPrimitive());
    }

    countSlot(priceRuleId?: string): Observable<number> {
        const params = {priceRuleId};
        return this.http.get<Primitive<number>>(`${this.entityUrl}/countSlot`, {params}).pipe(this.mapPrimitive());
    }

    protected covertFromServer(entity: PriceRule): PriceRule {
        return {
            ...entity,
            season: {
                start: toDate(entity.season?.start),
                end: toDate(entity.season?.end)
            }
        };
    }

    // protected covertToServer(entity: PriceRuleWrapper): PriceRule {
    //     return {
    //         ...entity,
    //         season: convertSeasonToServer(entity.season)
    //     };
    // }
}

